import memoizee from 'memoizee';
import {convertUserToParticipant} from './convertUserToParticipant';

export const mergeUsersToParticipants = memoizee(
    (participants, users) => {
        for (let user of users) {
            if (!participants.find(p => p.user_id == user.id)) {
                participants = [...participants, convertUserToParticipant(user)];
            }
        }
        return participants;
    },
    {maxAge: 300000}
);
